import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeadingModule } from '../../atoms/heading/heading.module';
import { ImageModule } from '../../atoms/image/image.module';
import { TextModule } from '../../atoms/text/text.module';
import { SharedBannerSlimComponent } from './banner-slim.component';

@NgModule({
  imports: [CommonModule, ImageModule, HeadingModule, TextModule],
  declarations: [SharedBannerSlimComponent],
  exports: [SharedBannerSlimComponent]
})
export class BannerSlimModule {}
